import { ExtractRouteParams } from "@CommonUtils/routes";

/**
 * The racks a category's store fixtures hold: special fixtures whose boards (tiers) carry a
 * PSA Assembly ending with "RACK", e.g. "WIPES RACK". For the shelf picker of the variant
 * restriction rules: "Rack: <name>" / "Not rack: <name>" target one rack, "Rack" / "Not rack"
 * any rack.
 */
export const RouteGetCategories_categoryId_Racks = "/categories/:categoryId/racks";

export type ParamsGetCategories_categoryId_Racks = ExtractRouteParams<
  typeof RouteGetCategories_categoryId_Racks
>;

export interface CategoryRack {
  /** The assembly, trimmed, single-spaced and upper-cased: the name rules use. */
  name: string;
  /** The stores whose fixture holds this rack: how many boards it has there, and the
   *  merchant_fixture_ids of the host shelves they stand on (pinned with them in generation). */
  stores: { storeId: number; storeCode: string; tiers: number; standsOn: string[] }[];
}

export interface ResponseGetCategories_categoryId_Racks {
  racks: CategoryRack[];
}
